// @core/api/endpoints/workflow/pause_execution.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PauseExecutionRequest,
  PipelineExecutionResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Pause execution
 * Pauses a running pipeline execution. The currently executing node will complete, but no new nodes will start until resumed. Used for human-in-the-loop workflows, approvals, and debugging.
 */
export async function PauseExecution(
  execution_id: string,
  data: PauseExecutionRequest,
  options?: RequestOptions
): Promise<PipelineExecutionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/executions/:execution_id/pause`;
  requestPath = requestPath.replace(':execution_id', encodeURIComponent(execution_id));
  const requestOptions = options;
  return client.post<PipelineExecutionResponse>(requestPath, data, requestOptions);
}
